import { FormErrors } from 'redux-form';
import {
  isRequiredValidator,
  isOfMinLength,
  hasAtLeastOneLetter,
  hasAtLeastOneNumber,
} from 'logic/validators/validators';
import { clearEmptyFields } from 'logic/validators/utils';
import { TaxIdType } from 'logic/api-models/payments';

export const BILLING_INFO_FORM_NAME = 'billing-info-form';
export const DEFAULT_VAT_ID_TYPE = 'eu_vat';
export enum BillingInfoFormFields {
  CompanyName = 'companyName',
  Address1 = 'addressLine1',
  Country = 'country',
  City = 'city',
  ZIP = 'postalCode',
  VAT = 'taxIdValue',
  VAT_ID = 'taxIdType',
  DefaultPaymentMethod = 'defaultPaymentMethod',
}

export type BillingInfoFormValues = {
  [BillingInfoFormFields.CompanyName]: string;
  [BillingInfoFormFields.Address1]: string;
  [BillingInfoFormFields.Country]: string;
  [BillingInfoFormFields.City]: string;
  [BillingInfoFormFields.ZIP]: string;
  [BillingInfoFormFields.VAT]?: string;
  [BillingInfoFormFields.VAT_ID]?: TaxIdType;
  [BillingInfoFormFields.DefaultPaymentMethod]?: string;
};

export type BillingInfoFormErrors = FormErrors<BillingInfoFormValues, any>;

export const validateBillingInfoForm = (values: BillingInfoFormValues) => {
  const { addressLine1, companyName, country, postalCode, city } = values;

  const errors: Partial<BillingInfoFormErrors> = {
    [BillingInfoFormFields.CompanyName]:
      isRequiredValidator(companyName) || isOfMinLength(companyName, 1),
    [BillingInfoFormFields.Address1]:
      isRequiredValidator(addressLine1) ||
      isOfMinLength(addressLine1, 3) ||
      hasAtLeastOneLetter(addressLine1),
    [BillingInfoFormFields.Country]: isRequiredValidator(country) || isOfMinLength(country, 2),
    [BillingInfoFormFields.City]:
      isRequiredValidator(city) || isOfMinLength(city, 2) || hasAtLeastOneLetter(city),
    [BillingInfoFormFields.ZIP]: isRequiredValidator(postalCode) || hasAtLeastOneNumber(postalCode),
  };

  return clearEmptyFields(errors);
};
